<template>
  <div>
    <rabbey-top-menu />
    <!-- //dialogo para asignar responsable -->
    <el-dialog
      title=""
      :visible.sync="dialogValorationVisible"
      width="30%"
      :before-close="handleCloseValoration"
    >
      <h2>
        Gracias por validar la solicitud, ahora por favor <br />
        califique el servicio brindado
      </h2>
      <el-rate
        v-model="value"
        :colors="colors"
        :texts="['muy malo', 'malo', 'regular', 'bueno', 'excelente']"
        show-text
      >
      </el-rate>
      <div v-if="value < 5">
        <label
          >como puedo mejorar mi servicio para que tu experiencia sea excelente
        </label>
        <el-input
          type="textarea"
          :rows="2"
          placeholder="Please input"
          v-model="comment"
        >
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogValorationVisible = false">Cancel</el-button>
        <el-button type="primary">Confirm</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "validatePage",
  components: {},
  data() {
    return {
      dialogValorationVisible: true,
      comment: "",
      value: 0,
      colors: ["#FF0000", "#F7BA2A", "#72a63d"],
      iconClasses: [
        "icon-rate-face-1 x3",
        "icon-rate-face-2",
        "icon-rate-face-3"
      ] // same as { 2: 'icon-rate-face-1', 4: { value: 'icon-rate-face-2', excluded: true }, 5: 'icon-rate-face-3' }
    };
  }
};
</script>
<style lang="stylus"></style>
